import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import { ResponseWithPagination, TChatTypeUnion } from 'constants/types'
import { IChat, IUnreadCount } from 'redux/store/chats/types'
import { Avatar } from '../UserProfile/types'

const fetcher = new Fetcher({})

export type TChatVendorUserInfo = {
  uuid: string
  first_name: string
  last_name: string
  role: string
  avatar: Avatar | null
  email: string
  organization_name: string
  facility_name?: string
  phone_number: string
}

export type GetChatListRequestArgs = {
  limit?: number
  offset?: number
  search?: string
  type?: TChatTypeUnion
  query?: string
}

export const getUnreadMessagesRequestAsync = async () =>
  fetcher.request<unknown, IUnreadCount>({
    url: `${API_DICTIONARY.CHATS}${API_DICTIONARY.UNREAD_COUNT}`,
    method: HTTP_METHODS.GET
  })

export const getChatListRequestAsync = async (params: GetChatListRequestArgs) =>
  fetcher.request<unknown, ResponseWithPagination<IChat>>({
    url: `${API_DICTIONARY.CHATS}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getPvpAvailableUsers = async (params) =>
  fetcher.request<
    unknown,
    ResponseWithPagination<Partial<TChatVendorUserInfo>>
  >({
    url: `${API_DICTIONARY.CHATS}${API_DICTIONARY.PVP_AVAILABLE_USERS}`,
    method: HTTP_METHODS.GET,
    params
  })

export const getGroupAvailableUsers = async (params) =>
  fetcher.request<
    unknown,
    ResponseWithPagination<Partial<TChatVendorUserInfo>>
  >({
    url: `${API_DICTIONARY.CHATS}${API_DICTIONARY.GROUP_AVAILABLE_USERS}`,
    method: HTTP_METHODS.GET,
    params
  })

type CreateChatRequestData = {
  name: string
  description?: string
  members: string[]
  type?: string
}

type CreatePvPChatRequestData = {
  description?: string
  members: string[]
  type?: string
}

export const createChatRequest = async (
  data: CreateChatRequestData | CreatePvPChatRequestData
) =>
  fetcher.request<unknown, IChat>({
    url: `${API_DICTIONARY.CHATS}`,
    method: HTTP_METHODS.POST,
    data
  })

export const readChatMessages = async (id: string) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.CHATS}${id}/${API_DICTIONARY.MARK_AS_READ}`,
    method: HTTP_METHODS.POST
  })
